export default __webpack_public_path__ + "static/media/gartner-rating.e9bf1199.png";